/* Beltek Food Service — límite de cantidad por producto en el pedido.
   Lee window.BeltekLimits (variantId -> max) y lo aplica a los inputs de cantidad
   (página de producto y carrito). Usa el mecanismo nativo de Dawn (atributo max). */
(function () {
  'use strict';
  var LIMITS = window.BeltekLimits || {};
  var DEBOUNCE = null;

  function maxFor(input) {
    var vid = input.getAttribute('data-quantity-variant-id');
    if (!vid) return null;
    var m = LIMITS[vid];
    return (typeof m === 'number' && m > 0) ? m : null;
  }

  function noteFor(input) {
    var wrap = input.closest('quantity-input') || input.parentElement;
    if (!wrap || !wrap.parentElement) return null;
    var host = wrap.parentElement;
    var note = host.querySelector(':scope > .beltek-qty-note');
    if (!note) {
      note = document.createElement('div');
      note.className = 'beltek-qty-note';
      note.setAttribute('role', 'status');
      note.style.cssText = 'font-size:1.2rem;line-height:1.3;color:rgb(200,30,30);margin-top:.5rem;display:none;';
      host.appendChild(note);
    }
    return note;
  }

  function showNote(input, max) {
    var note = noteFor(input);
    if (!note) return;
    note.textContent = 'Máximo ' + max + ' por pedido. Para más piezas, realiza otro pedido o escríbenos por WhatsApp (442 595 3216).';
    note.style.display = 'block';
    clearTimeout(note._t);
    note._t = setTimeout(function () { note.style.display = 'none'; }, 7000);
  }

  function apply(input) {
    var max = maxFor(input);
    if (max == null) return;
    input.setAttribute('max', String(max));
    input.dataset.beltekMax = String(max);

    var val = parseInt(input.value, 10);
    if (!isNaN(val) && val > max) {
      input.value = String(max);
      showNote(input, max);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      val = max;
    }

    var qi = input.closest('quantity-input');
    if (qi) {
      var plus = qi.querySelector('button[name="plus"]');
      if (plus) plus.toggleAttribute('disabled', (isNaN(val) ? 0 : val) >= max);
    }
  }

  function handle(e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
    apply(input);
  }

  function applyAll(root) {
    (root || document)
      .querySelectorAll('input.quantity__input[data-quantity-variant-id]')
      .forEach(apply);
  }

  function scheduleApplyAll() {
    clearTimeout(DEBOUNCE);
    DEBOUNCE = setTimeout(function () { applyAll(); }, 120);
  }

  document.addEventListener('input', handle, true);
  document.addEventListener('change', handle, true);

  function init() {
    applyAll();
    var target = document.getElementById('main-cart-items')
      || document.querySelector('cart-drawer')
      || document.getElementById('MainContent');
    if (target) {
      try {
        new MutationObserver(scheduleApplyAll).observe(target, { childList: true, subtree: true });
      } catch (err) { /* noop */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
